export const safeParse = (string, defaultStore = null) => {
  if (!string) return defaultStore
  try {
    return JSON.parse(string)
  } catch (error) {
    return defaultStore
  }
}
